export const anonymizationOptions = [
	'user',
	'user_name',
	'user_email',
	'user_employeeNumber',
	'user_comment',
	'dutyActivity',
	'notification',
	'agreement',
	'exchange',
	'report',
	'duty',
	'absence',
];
